import { AddressComponent } from "modules/cart/address-component";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, useLocation } from "react-router-dom";
import { createCartApi } from "states/cart/cart.api";
import { globalValueSetLoading, globalValueSetStepper, globalValueSetToast } from "states/global-value/global-value.action";
import { Stepper, ToastModel, ToastType } from "states/global-value/global-value.models";
import { RootState } from "../../app.store";
import { InfoComponent } from "./info";
import "./payment.less";
interface PaymentProps {}
const Payment = (props: PaymentProps) => {
  const dispatch = useDispatch();
  const model = useSelector((state: RootState) => state.cart);
  const [ orderNumber, setOrderNumber ] = useState<string | number>("");
  const [isRedirect, setIsRedirect] = useState<boolean>(false);
  const _createdOrder = async () =>{
    dispatch(globalValueSetLoading(true));
    try{
     let response = await createCartApi();
     dispatch(globalValueSetLoading(false));
      if (response.data !== null){
        setOrderNumber(response.data);
        setIsRedirect(true);
      }
    }catch(error){
      dispatch(globalValueSetLoading(false));
      dispatch(
        globalValueSetToast({
          message: error?.response?.data?.error?.message,
          type: ToastType.error,
        } as ToastModel)
      );
    }
  }
  const redirect = () =>{
    if(!isRedirect) return false;
    return <Redirect to={`/cart/checkout/${orderNumber}`} />
  }
  useEffect(()=>{
    document.title = "Đặt hàng";
    dispatch(globalValueSetStepper(Stepper.Checkout));
  },[])
  return (
    <div className="flex-container shopping-cart-container">
      <div className="payment-info-container">
        <AddressComponent
           address={model.address}
           email={model.email}
           districtName={model.districtName}
           provinceName={model.provinceName}
           wardName={model?.wardName}
           phone={model?.shipName}
           name={model.shipPhoneNumber}
        />
        <InfoComponent
          orderItems={model.shoppingCartItems}
          subTotal={model.subTotalAmount}
          total={model.totalAmount}
          discount={model.discountAmount}
          shippingFee={model.shippingFee}
        />
           <div className="btn-container btn-confirm m-top-4">
            <button onClick={_createdOrder}  className="btn btn-primary text-uppercase">
              Đặt hàng ngay
            </button>
          </div>
      </div>
      {redirect()}
    </div>
  );
};
export default Payment;
